import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { meService } from '../services/me.service';
import { useAuthStore } from '../stores/authStore';

/**
 * Probes the session once on mount and mirrors the result into the auth store.
 *
 * The query is the source of truth; the store exists so route guards and the
 * header can read the identity without every component holding a query.
 */
export const useSession = () => {
    const setSession = useAuthStore((s) => s.setSession);
    const clearSession = useAuthStore((s) => s.clearSession);

    const query = useQuery({
        queryKey: ['me'],
        queryFn: () => meService.get(),
        retry: false,
        staleTime: 5 * 60_000,
        // Being signed out is a settled answer, not a transient failure worth
        // re-asking on every window focus.
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (query.data) {
            setSession({
                id: query.data.id,
                handle: query.data.handle,
                isAdmin: query.data.isAdmin,
            });
        } else if (query.isError) {
            clearSession();
        }
    }, [query.data, query.isError, setSession, clearSession]);

    return query;
};
